export const buildCampaignProductsExcelHeaders = () => ({
  product_id: "شناسه کالا",
  product_name: "نام کالا",
  product_code: "کد کالا",
  product_brand: "برند",
  product_category: "دسته‌بندی",
  supplier_name: "تامین‌کننده",
  created_at: "تاریخ افزودن",
});